import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Modal, Switch, Stack, SimpleGrid, TextInput, Textarea, PasswordInput, Center, Box, Progress, Badge, NumberInput, PinInput, Checkbox, Skeleton } from "@mantine/core";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider, Empty, Spin,
    Alert,
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import dayjs from "dayjs";
import { Admin_Bank_Add, Admin_Bank_Delete, Admin_Banks_get, Get_All_Users, Get_Individual_user_wallet_details, Get_Portal_Configuration, Get_Portal_Updates, Master_Dist_Signup, Portal_Configuration, Portal_Updates, Sendotp, Update_Master_dist_details, Update_user_wallet_hold_balance, Update_user_wallet_status } from "../../../apicall";
import { IconCheck, IconX } from "@tabler/icons-react";
import {
    IconWorld,
    IconUsers,
    IconBuildingStore,
    IconShieldCheck
} from "@tabler/icons-react";
import JoditEditor from "jodit-react";
const { Search } = Input;










const Publishupdates = ({ Headername }) => {
    const MAX_DESCRIPTION_LENGTH = 100; // for descrptions
    const editor = useRef(null);
    const config = useMemo(
        () => ({
            readonly: false,
            placeholder: "Write announcement details (Optional)...",
            height: 300,
        }),
        []
    );
    const { user } = Userauthcontexthooks();
    const [fetchedUpdates, setfetchedupdates] = useState('');
    const [fetchedPublishedloading, setfetchedPublishloading] = useState(true);
    const [announcement, setAnnouncement] = useState({
        title: "",
        description: "",
    });
    const [Submitpublishloading, setPublishloading] = useState(false);

    const getPlainText = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    const fetchPublishupdates = async () => {
        try {
            const data = await Get_Portal_Updates();
            if (data.success) {
                //console.log(data);
                setfetchedupdates(data?.LatestUpdates);
                setAnnouncement({
                    title: data?.LatestUpdates?.UpdateTitle,
                    description: data?.LatestUpdates?.UpdateDiscription,
                });
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setfetchedPublishloading(false);
        }
    }
    const Publish_Updates = async () => {
        const { title, description } = announcement;
        if (!title) {
            message.error("Title are required");
            return;
        }
        const body = {
            UpdateTitle: title,
            UpdateDiscription: description
        }
        try {
            setPublishloading(true);
            const data = await Portal_Updates(body);
            if (data.success) {
                message.success(data?.message);
                // setConfigModal(false);
                //setInputotp('');
                fetchPublishupdates();
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setPublishloading(false);
        }

    }

    useEffect(() => {
        const fetchPublishupdates = async () => {
            try {
                const data = await Get_Portal_Updates();
                if (data.success) {
                    //console.log(data);
                    setfetchedupdates(data?.LatestUpdates);
                    setAnnouncement({
                        title: data?.LatestUpdates?.UpdateTitle,
                        description: data?.LatestUpdates?.UpdateDiscription,
                    });
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setfetchedPublishloading(false);
            }
        }

        if (user) {
            fetchPublishupdates();
        }

    }, [user])
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Publish Updates</Title>
                <Text size="xs">You can publish services updates and other updates.</Text>
            </Container>
            <Container size={'lg'} mt={'lg'}>
                <Skeleton visible={fetchedPublishedloading}>
                    <Card shadow="sm" radius="md" withBorder>
                        <TextInput
                            mb={'sm'}
                            label="Announcement Title"
                            placeholder="Enter announcement title"
                            withAsterisk
                            value={announcement.title}
                            onChange={(e) =>
                                setAnnouncement({
                                    ...announcement,
                                    title: e.target.value,
                                })
                            }
                        />

                        <JoditEditor
                            ref={editor}
                            value={announcement.description}
                            config={config}
                            onBlur={(newContent) => {

                                const plainText = getPlainText(newContent);

                                if (plainText.length <= MAX_DESCRIPTION_LENGTH) {
                                    setAnnouncement((prev) => ({
                                        ...prev,
                                        description: newContent,
                                    }));
                                }
                            }}
                        />
                    </Card>
                </Skeleton>


                <Card
                    style={{ marginTop: '5px', marginBottom: '5px' }}
                >

                    <Group justify="space-between">

                        <Group>

                            <ThemeIcon
                                color="green"
                                variant="light"
                                radius="xl"
                            >
                                <IconShieldCheck size={18} />
                            </ThemeIcon>

                            <div>

                                <Text fw={700}>
                                    Publish
                                </Text>

                                <Text size="sm" c="dimmed">
                                    Announcement will immediately affect portal accessibility.
                                </Text>

                            </div>

                        </Group>

                        <Button
                            //disabled={!hasChanges}
                            onClick={Publish_Updates}
                            loading={Submitpublishloading}
                        >
                            Publish Announcement
                        </Button>

                    </Group>

                </Card>
            </Container>


        </>
    )
}

export default Publishupdates;